export default function (createEnquiry, $state, toaster, getVehicleDetailsCheck, getDealersByNumber, vehicleSourced, enquiryReportType) {
    const vm = this;

    vm.model = {};
    vm.form = null;
    vm.isLoadingVehicleDetails = false;
    vm.dealers = [];
    vm.isLoadingDealers = true;
    vm.vehicleSourced = [];
    vm.lastVrm = null;
    vm.vmcAccountsPage = 1;
    vm.isDateOfPurchaseRequired = true;
    vm.isMileageWhenPurchasedRequired = true;
    vm.isDateWhenSoldRequired = true;
    vm.isMileageWhenSoldRequired = true;
    vm.enquiryReportType = [];
    vm.mxinLite = {
        disallowEnquiryCreation: false
    };

    /* --- */

    vm.create = create;
    vm.vrmChanged = vrmChanged;
    vm.getDealersWithFilter = getDealersWithFilter;
    vm.isDateRequired = isDateRequired;
    vm.mileageWhenPurchasedAccuracyChanged = mileageWhenPurchasedAccuracyChanged;
    vm.dateOfPurchaseAccuracyChanged = dateOfPurchaseAccuracyChanged;
    vm.mileageWhenPurchasedAccuracyChanged = mileageWhenPurchasedAccuracyChanged;
    vm.dateWhenSoldAccuracyChanged = dateWhenSoldAccuracyChanged;
    vm.mileageWhenSoldAccuracyChanged = mileageWhenSoldAccuracyChanged;
    vm.isDateOfPreviousVrmRequired = function () {
        return false;
    };

    /* --- */
    function getDealersWithFilter(filter, nextPage, $event) {
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }

        if (nextPage) {
            vm.vmcAccountsPage += 1;
        } else {
            vm.vmcAccountsPage = 1;
        }

        vm.isLoadingDealers = true;

        getDealersByNumber(vm.vmcAccountsPage, filter)
            .then(data => {
                if (nextPage) {
                    vm.dealers = vm.dealers.concat(data.dealers);
                } else {
                    vm.dealers = data.dealers;
                }
                vm.isLoadingDealers = false;
            });
    }

    vehicleSourced
        .then(s => {
            vm.vehicleSourced = s;
        });

    enquiryReportType
        .then(reportTypes => {
            vm.enquiryReportType = reportTypes;
            // Set Post/Email as default selected report type
            vm.model.reportType = 'Post/Email';
        });

    /* --- */

    function create() {
        if (vm.form.$invalid) {
            // FL: Should we consider a toaster here too?
            return;
        }

        // if (vm.mxinLite.disallowEnquiryCreation) {
        //     toaster.info('The messages returned from the Mainframe disallows an enquiry from being created. Please review the messages above.');
        //     return;
        // }

        if (vm.isLoadingVehicleDetails) {
            toaster.info('Please wait for the vehicle details to be populated before submitting');
            return;
        }

        vm.model.dealerId = vm.model.dealer.id;

        createEnquiry(vm.model)
            .then(() => {
                $state.go('enquiries.list');
                toaster.pop('success', 'The enquiry has been successfully created');
            })
            .catch(() => {
                toaster.pop('error', 'An error occured when creating an enquiry');
            });
    }

    function vrmChanged($event) {
        if ($event) {
            const keyCode = $event.which || $event.keyCode;
            if (keyCode === 13) {
                $event.stopPropagation();
                $event.preventDefault();
            } else if (keyCode !== 9) {
                return;
            }
        }

        if ((!vm.model.vrm && !vm.lastVrm) ||
            vm.model.vrm === vm.lastVrm) {
            return;
        }

        vm.lastVrm = vm.model.vrm;

        vm.isLoadingVehicleDetails = true;

        getVehicleDetailsCheck(vm.model.vrm)
            .then(vehicleDetails => {
                vm.isLoadingVehicleDetails = false;
                vm.model.vin = vehicleDetails.vin;
                vm.model.make = vehicleDetails.make;
                vm.model.model = vehicleDetails.model;
                vm.model.mostRecentKeeper = {};
                vm.model.previousKeeper = {};
                vm.model.numberOfKeepers = vehicleDetails.numberOfKeepers;
                vm.model.dateFirstRegistered = vehicleDetails.dateFirstRegistered;
                if (vehicleDetails.keeperChanges.length > 0) {
                    vm.model.mostRecentKeeperChanged = vehicleDetails.keeperChanges[vehicleDetails.keeperChanges.length - 1].dateChanged;
                }
                if (vehicleDetails.keeperChanges.length >= 2) {
                    vm.model.dateKeeperChanged = vehicleDetails.keeperChanges[vehicleDetails.keeperChanges.length - 2].dateChanged;
                }
                vm.mxinLite.messages = vehicleDetails.messages || [];
                const messagesThatBlockEnquiryCreation = vm.mxinLite.messages.filter(m => m.disallowEnquiryCreation);
                vm.mxinLite.disallowEnquiryCreation = messagesThatBlockEnquiryCreation.length > 0;
            })
            .catch(() => {
                vm.isLoadingVehicleDetails = false;
            });
    }

    function isDateRequired(accuracy) {
        return accuracy !== 300;
    }

    function dateOfPurchaseAccuracyChanged() {
        vm.isDateOfPurchaseRequired = vm.model.dateOfPurchaseAccuracy !== 300;

        if (!vm.isDateOfPurchaseRequired) {
            vm.model.dateOfPurchase = null;
        }
    }

    function mileageWhenPurchasedAccuracyChanged() {
        vm.isMileageWhenPurchasedRequired = vm.model.mileageWhenPurchasedAccuracy !== 300;

        if (!vm.isMileageWhenPurchasedRequired) {
            vm.model.mileageWhenPurchased = null;
        }
    }

    function dateWhenSoldAccuracyChanged() {
        vm.isDateWhenSoldRequired = vm.model.dateWhenSoldAccuracy !== 300;

        if (!vm.isDateWhenSoldRequired) {
            vm.model.dateWhenSold = null;
        }
    }

    function mileageWhenSoldAccuracyChanged() {
        vm.isMileageWhenSoldRequired = vm.model.mileageWhenSoldAccuracy !== 300;

        if (!vm.isMileageWhenSoldRequired) {
            vm.model.mileageWhenSold = null;
        }
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/controllers/enquiries/create/enquiryCreateCtrl.js